<div class="rule">
    <rule-detail [(rule)]="rule" [entite]="entite"></rule-detail>
</div>